export const initialStates = {
   apiResponseCode: '',
   slots: {},
   initialSlots: {},
   searchByPincode: true,
   identifier: '',
   dateSlotsAvailable: true
};

function formatSlots(inputArray = []) {
   const result = {}
   inputArray.length && inputArray.forEach((element) => {
      const { sessions, ...metaData } = element
      const { center_id } = metaData
      sessions.forEach((element) => {
         const { date, ...metaData2 } = element
         if (!result[date]) {
            result[date] = [{ ...metaData, 'sessions': [{ ...metaData2 }] }]
         } else {
            const { sessions, ...metaDataCenter } = result[date].pop()
            const { center_id: center_id_current } = metaDataCenter
            if (center_id == center_id_current) {
               sessions.push(metaData2)
               result[date].push({ ...metaDataCenter, sessions })
            } else {
               result[date].push({ ...metaDataCenter, sessions })
               result[date].push({ ...metaData, 'sessions': [{ ...metaData2 }] })
            }
         }
      })
   })
   let temp = {}

   const keys = Object.keys(result)

   const sortedKeys = keys.sort((key1, key2) => {
      const [day1, month1, year1] = key1.split('-')
      const [day2, month2, year2] = key2.split('-')
      if (Number(year1) < Number(year2)) {
         return -1
      } else if (Number(year1) > Number(year2)) {
         return 1
      } else {
         return Number(month1) < Number(month2) ? -1 :
            Number(month1) > Number(month2) ? 1 : Number(day1) < Number(day2) ? -1 : Number(day1) > Number(day2) ? 1 : 0
      }
   })

   sortedKeys.forEach((element) => {
      temp[element] = result[element]
      delete result[element]
   })

   return temp
}

function filterByDoseAvailability(available_capacity_dose1, available_capacity_dose2, inputObject) {
   const result = {}
   Object.keys(inputObject).forEach((date) => {
      const dateSpecificCenters = inputObject[date] || []
      const dateSpecificFilteredCenters = []
      dateSpecificCenters.forEach((center) => {
         const { sessions, ...metaData } = center
         const resultSessions = []
         sessions.forEach((session) => {
            if (available_capacity_dose1 && !available_capacity_dose2) {
               if (session['available_capacity_dose1'] !== 0) {
                  resultSessions.push({ ...session, 'available_capacity': session['available_capacity_dose1'] })
               }
            } else if (!available_capacity_dose1 && available_capacity_dose2) {
               if (session['available_capacity_dose2'] !== 0) {
                  resultSessions.push({ ...session, 'available_capacity': session['available_capacity_dose2'] })
               }
            } else if (available_capacity_dose1 && available_capacity_dose2) {
               if (session['available_capacity_dose2'] !== 0 && session['available_capacity_dose1'] !== 0) {
                  resultSessions.push(session)
               }
            } else {
               if (session['available_capacity'] !== 0 && (session['available_capacity_dose2'] + session['available_capacity_dose1']) !== 0) {
                  resultSessions.push(session)
               }
            }
         })
         if (resultSessions.length) {
            dateSpecificFilteredCenters.push({ ...metaData, 'sessions': resultSessions })
         }
      })
      if (dateSpecificFilteredCenters.length) {
         result[date] = dateSpecificFilteredCenters
      }
   })
   return result
}

function filterByDoseUnAvailability(available_capacity_dose1, available_capacity_dose2, inputObject) {
   const result = {}
   Object.keys(inputObject).forEach((date) => {
      const dateSpecificCenters = inputObject[date] || []
      const dateSpecificFilteredCenters = []
      dateSpecificCenters.forEach((center) => {
         const { sessions, ...metaData } = center
         const resultSessions = []
         sessions.forEach((session) => {
            if (available_capacity_dose1 && !available_capacity_dose2) {
               resultSessions.push({ ...session, 'available_capacity': session['available_capacity_dose1'] })
            } else if (!available_capacity_dose1 && available_capacity_dose2) {
               resultSessions.push({ ...session, 'available_capacity': session['available_capacity_dose2'] })
            } else {
               resultSessions.push(session)
            }
         })
         if (resultSessions.length) {
            dateSpecificFilteredCenters.push({ ...metaData, 'sessions': resultSessions })
         }
      })
      if (dateSpecificFilteredCenters.length) {
         result[date] = dateSpecificFilteredCenters
      }
   })
   return result
}

function filterByAge(keyword, expected, inputObject) {
   const result = {}
   Object.keys(inputObject).forEach((date) => {
      const dateSpecificCenters = inputObject[date] || []
      const dateSpecificFilteredCenters = []
      dateSpecificCenters.forEach((center) => {
         const { sessions, ...metaData } = center
         const resultSessions = []
         sessions.forEach((session) => {
            if (expected.indexOf(session[keyword]) >= 0) {
               resultSessions.push(session)
            }
         })
         if (resultSessions.length) {
            dateSpecificFilteredCenters.push({ ...metaData, sessions: resultSessions })
         }
      })
      if (dateSpecificFilteredCenters.length) {
         result[date] = dateSpecificFilteredCenters
      }
   })
   return result
}

function filterByVaccineName(keyword, expected, inputObject) {
   const result = {}
   Object.keys(inputObject).forEach((date) => {
      const dateSpecificCenters = inputObject[date] || []
      const dateSpecificFilteredCenters = []
      dateSpecificCenters.forEach((center) => {
         const { sessions, ...metaData } = center
         const resultSessions = []
         sessions.forEach((session) => {
            if (expected.indexOf(session[keyword]) >= 0) {
               resultSessions.push(session)
            }
         })
         if (resultSessions.length) {
            dateSpecificFilteredCenters.push({ ...metaData, sessions: resultSessions })
         }
      })
      if (dateSpecificFilteredCenters.length) {
         result[date] = dateSpecificFilteredCenters
      }
   })
   return result
}
function filterByCost(keyword, expected, inputObject) {
   const result = {}
   Object.keys(inputObject).forEach((date) => {
      const dateSpecificCenters = inputObject[date] || []
      const dateSpecificFilteredCenters = []
      dateSpecificCenters.forEach((center) => {
         const { sessions, ...metaData } = center
         const resultSessions = []
         sessions.forEach((session) => {
            if (expected.indexOf(metaData[keyword]) >= 0) {
               resultSessions.push(session)
            }
         })
         if (resultSessions.length) {
            dateSpecificFilteredCenters.push({ ...metaData, sessions: resultSessions })
         }
      })
      if (dateSpecificFilteredCenters.length) {
         result[date] = dateSpecificFilteredCenters
      }
   })
   return result
}


function filter(keywords, slots) {
   const {
      available_capacity,
      available_capacity_dose1,
      available_capacity_dose2,
      covaxin, covishield,
      sputnik,
      min_age_limit_18,
      min_age_limit_45,
      fee_type_free,
      fee_type_paid
   } = keywords
   let result = slots
   if (available_capacity) {
      result = filterByDoseAvailability(available_capacity_dose1, available_capacity_dose2, result)
   } else {
      result = filterByDoseUnAvailability(available_capacity_dose1, available_capacity_dose2, result)
   }
   const vaccineNameToFilterBy = []

   if (covaxin) {
      vaccineNameToFilterBy.push('COVAXIN')
   }
   if (covishield) {
      vaccineNameToFilterBy.push('COVISHIELD')
   }
   if (sputnik) {
      vaccineNameToFilterBy.push('SPUTNIK V')
   }
   if (vaccineNameToFilterBy.length) {
      result = filterByVaccineName('vaccine', vaccineNameToFilterBy, result)
   }
   const ageLimitToFilterBy = []
   if (min_age_limit_45) {
      ageLimitToFilterBy.push(45)
   }
   if (min_age_limit_18) {
      ageLimitToFilterBy.push(18)
      ageLimitToFilterBy.push(45)
   }
   if (ageLimitToFilterBy.length) {
      result = filterByAge('min_age_limit', ageLimitToFilterBy, result)
   }
   const feeTypeToFilterBy = []
   if (fee_type_free) {
      feeTypeToFilterBy.push('Free')
   }
   if (fee_type_paid) {
      feeTypeToFilterBy.push('Paid')
   }
   if (feeTypeToFilterBy.length) {
      result = filterByCost('fee_type', feeTypeToFilterBy, result)
   }
   return result
}


const reducer = (state, action) => {
   switch (action.type) {
      case "ADD_DETAILS":
         const formattedSlots = formatSlots(action.slots)
         return {
            ...state,
            slots: formattedSlots,
            initialSlots: formattedSlots,
            searchByPincode: action.searchByPincode,
            identifier: action.identifier,
            apiResponseCode: 'success'
         }
      case "SET_RESPONSE_CODE":
         return {
            ...state,
            apiResponseCode: action.apiResponseCode
         }
      case "SET_DATE_SLOTS":
         return {
            ...state,
            dateSlotsAvailable: action.dateSlotsAvailable
         }
      case "FILTER":
         return {
            ...state,
            slots: { ...filter(action.keywords, action.initialSlots) },
         };
      default:
         return state;
   }
};

export default reducer;